<template>
  <div>
<!--    <div class="layoutJSON">-->
<!--      Displayed as <code>[x, y, w, h]</code>:-->
<!--      <div class="columns">-->
<!--        <div class="layoutItem" v-for="item in layout" :key="item.i">-->
<!--          <b>{{item.i}}</b>:-->
<!--          <br/>-->
<!--          [{{item.x}}, {{item.y}}, {{item.w}}, {{item.h}}]-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <button @click="addItem">Add an item dynamically</button>-->
<!--    <input type="checkbox" v-model="draggable" /> Draggable-->
<!--    <input type="checkbox" v-model="resizable" /> Resizable-->
<!--    <input type="checkbox" v-model="verticalCompact" /> Vertical Compact-->
    <grid-layout :layout.sync="layout"
                 :col-num="colNum"
                 :row-height="20"
                 :is-draggable="draggable"
                 :is-resizable="resizable"
                 :vertical-compact="verticalCompact"
                 :use-css-transforms="true"
    >
      <grid-item v-for="item in layout"
                 :static="item.static"
                 :x="item.x"
                 :y="item.y"
                 :w="item.w"
                 :h="item.h"
                 :i="item.i"
                 :key="item.i"
                 drag-allow-from=".vue-draggable-handle"
                 drag-ignore-from=".no-drag"
      >
        <div>
          <div class="vue-draggable-handle"></div>
          <div class="no-drag">
            <CommonCard :cardID="item.i" :cardType="item.type" :data="item.data"/>
            <span class="remove" @click="removeItem(item.i)">x</span>
          </div>
        </div>
      </grid-item>
    </grid-layout>
  </div>
</template>

<script>
import { GridLayout, GridItem } from "vue-grid-layout"
import CommonCard from "@/components/tools/CommonCard";
export default {
  name: "MyGridLayout",
  components: {
    CommonCard,
    GridLayout,
    GridItem
  },
  data() {
    return {
      layout: [
        // { x: 0, y: 0, w: 4, h: 15, i: "0", type: "TruthImageCard", data:{picText: "asd", groundtruth_source: "http://43.138.27.12:8081/file/20210101/IDC/groundtruth.png"} },
        // { x: 4, y: 0, w: 4, h: 15, i: "1", type: "InfoCard", data:{info: {types: [], spotSize: 1, tip: [], source: []}, info_type: "spatial domain"} },
        // { x: 8, y: 0, w: 4, h: 15, i: "2", type: "InfoCard", data:{info: {types: [], spotSize: 1, tip: [], source: []}, info_type: "celltype"} },
        // { x: 0, y: 1, w: 4, h: 15, i: "3", type: "InfoCard", data:{info: {types: [], spotSize: 1, tip: [], source: []}, info_type: "celltype_major"} },
        // { x: 4, y: 1, w: 4, h: 15, i: "4", type: "InfoCard", data:{info: {types: [], spotSize: 1, tip: [], source: []}, info_type: "celltype_minor"} },
        // { x: 8, y: 1, w: 4, h: 15, i: "5", type: "InfoCard", data:{info: {types: [], spotSize: 1, tip: [], source: []}, info_type: "celltype_subset"} },
      ],
      draggable: true,
      resizable: false,
      verticalCompact: true,
      colNum: 12,
      index: 0,
      eventLog: [],
    }
  },
  watch: {
    eventLog: function() {
      const eventsDiv = this.$refs.eventsDiv;
      eventsDiv.scrollTop = eventsDiv.scrollHeight;
    }
  },
  props:{
    layoutData: Array,
  },
  mounted() {
    // this.$gridlayout.load();
    this.layout = this.layoutData
    this.index = this.layout.length
    this.$nextTick(function () {
      // this.initLayoutData()
    })
  },
  methods: {
    // layout init method
    moveEvent: function(i, newX, newY){
      const msg = "MOVE i=" + i + ", X=" + newX + ", Y=" + newY;
      this.eventLog.push(msg);
      console.log(msg);

    },
    movedEvent: function(i, newX, newY){
      const msg = "MOVED i=" + i + ", X=" + newX + ", Y=" + newY;
      this.eventLog.push(msg);
      console.log(msg);

    },
    resizeEvent: function(i, newH, newW, newHPx, newWPx){
      const msg = "RESIZE i=" + i + ", H=" + newH + ", W=" + newW + ", H(px)=" + newHPx + ", W(px)=" + newWPx;
      this.eventLog.push(msg);
      console.log(msg);
    },
    resizedEvent: function(i, newX, newY, newHPx, newWPx){
      const msg = "RESIZED i=" + i + ", X=" + newX + ", Y=" + newY + ", H(px)=" + newHPx + ", W(px)=" + newWPx;
      this.eventLog.push(msg);
      console.log(msg);

    },
    containerResizedEvent: function(i, newH, newW, newHPx, newWPx){
      const msg = "CONTAINER RESIZED i=" + i + ", H=" + newH + ", W=" + newW + ", H(px)=" + newHPx + ", W(px)=" + newWPx;
      this.eventLog.push(msg);
      console.log(msg);
    },
    layoutCreatedEvent: function(newLayout){
      this.eventLog.push("Created layout");
      console.log("Created layout: ", newLayout)
    },
    layoutBeforeMountEvent: function(newLayout){
      this.eventLog.push("beforeMount layout");
      console.log("beforeMount layout: ", newLayout)
    },
    layoutMountedEvent: function(newLayout){
      this.eventLog.push("Mounted layout");
      console.log("Mounted layout: ", newLayout)
    },
    layoutReadyEvent: function(newLayout){
      this.eventLog.push("Ready layout");
      console.log("Ready layout: ", newLayout)
    },
    layoutUpdatedEvent: function(newLayout){
      this.eventLog.push("Updated layout");
      console.log("Updated layout: ", newLayout)
    },
    addItem: function () {
      // Add a new item. It must have a unique key!
      this.layout.push({
        x: (this.layout.length * 4) % (this.colNum || 12),
        y: this.layout.length + (this.colNum || 12), // puts it at the bottom
        w: 4,
        h: 15,
        i: this.index.toString(),
      });
      // Increment the counter to ensure key is always unique.
      this.index++;
    },
    removeItem: function (val) {
      const index = this.layout.map(item => item.i).indexOf(val);
      this.layout.splice(index, 1);
    },
    // my method
    initLayoutData: function () {
      let index = 0
      let temp_layout = []
      if (this.asynGround !== '' || this.asynGround.length !== 0){
        temp_layout.push({
          x: Math.round((index % 3) * 4),
          y:  Math.round(index / 3),
          w: 4,
          h: 15,
          i: index.toString(),
          type: "TruthImageCard",
          data:{
            picText: this.picText,
            groundtruth_source: this.asynGround
          }
        },)
        index++
      }
      let item;
      for(item in this.echart_info) {
        if (this.echart_info[item].source.length !== 0){
          let info_pic = ''
          switch (item) {
            case 'classification_info':
              info_pic = 'spatial domain';
              break;
            case 'annot_type_info':
              info_pic = 'anno_true';
              break;
            case 'fine_annot_type_info':
              info_pic = 'fine_anno_true';
              break;
            case 'celltype_info':
              info_pic = 'celltype';
              break;
            case 'major_info':
              info_pic = 'celltype_major';
              break;
            case 'minor_info':
              info_pic = 'celltype_minor';
              break;
            case 'subset_info':
              info_pic = 'celltype_subset';
              break;
          }
          // console.log(item)
          // console.log(this.echart_info[item])
          // console.log(info_pic)
          temp_layout.push({
            x: Math.round((index % 3) * 4),
            y: Math.round(index / 3),
            w: 4,
            h: 15,
            i: index.toString(),
            type: "InfoCard",
            data:{
              info: this.echart_info[item],
              info_type: info_pic
            },
          },)
          index++;
        }
      }
      for(item in this.echart_info) {
        if (this.echart_info[item].source.length !== 0){
          temp_layout.push({
            x: Math.round((index % 3) * 4),
            y: Math.round(index / 3),
            w: 4,
            h: 15,
            i: index.toString(),
            type: "PieCard",
            data:{
              info: this.echart_info[item],
              info_type: item
            },
          },)
          index++;
        }
      }
      // console.log("temp_layout")
      // console.log(temp_layout)
      this.layout = temp_layout
      this.index = this.layout.length;
    },
    addCard: function () {
    }
  }
}
</script>

<style scoped>

.layoutJSON {
  background: #ddd;
  border: 1px solid black;
  margin-top: 10px;
  padding: 10px;
}

.columns {
  -moz-columns: 120px;
  -webkit-columns: 120px;
  columns: 120px;
}

/*************************************/

.remove {
  position: absolute;
  right: 2px;
  top: 0;
  cursor: pointer;
}

.vue-grid-layout {
  /*background: #eee;*/
}

.vue-grid-item:not(.vue-grid-placeholder) {
  /*background: #ccc;*/
  border: 1px solid black;
}

.vue-grid-item .resizing {
  opacity: 0.9;
}

.vue-grid-item .static {
  background: #cce;
}

.vue-grid-item .text {
  font-size: 24px;
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 100%;
}

.vue-grid-item .no-drag {
  margin-top: 20px;
  height: 100%;
  width: 100%;
}

.vue-grid-item .minMax {
  font-size: 12px;
}

.vue-grid-item .add {
  cursor: pointer;
}

.vue-draggable-handle {
  position: absolute;
  width: 15px;
  height: 15px;
  z-index: 90;
  top: 0;
  left: 0;
  padding: 0 8px 8px 0;
  background-origin: content-box;
  background-color: black;
  box-sizing: border-box;
  border-radius: 10px;
  cursor: pointer;
}

.eventsJSON {
  background: #ddd;
  border: 1px solid black;
  margin-top: 10px;
  padding: 10px;
  height: 100px;
  overflow-y: scroll;
}

</style>
